// @flow

import * as React from 'react';

export function useScrollBottom(): {
  scrollBottom: boolean,
  elementRef: React.ElementRef<any>,
} {
  const elementRef = React.useRef<React.ElementRef<'div'> | null>(null);
  const element = elementRef.current;
  const [scrollBottom, setScrollBottom] = React.useState(false);

  const updateScrollState = React.useCallback(() => {
    if (!element) return;
    const { scrollTop, scrollHeight, offsetHeight } = element;
    setScrollBottom(scrollTop < scrollHeight - offsetHeight);
  }, [element]);

  React.useEffect(() => {
    if (!element) return;
    updateScrollState();

    element.addEventListener('scroll', updateScrollState);
    window.addEventListener('resize', updateScrollState);

    // eslint-disable-next-line consistent-return
    return () => {
      element.removeEventListener('scroll', updateScrollState);
      window.removeEventListener('resize', updateScrollState);
    };
  }, [element, updateScrollState]);
  return { scrollBottom, elementRef };
}
